import { ShipAddress } from "@types-runway/admin";

// "100 Test Street, Apt 4B, Miami, FL 33101": the street, the apartment when there is one,
// then the city, state and postal code.
export const describeShipAddress = (
  address: Pick<ShipAddress, "street" | "secondary" | "city" | "state" | "postalCode">
) => {
  const street = address.secondary ? `${address.street}, ${address.secondary}` : address.street;

  return `${street}, ${address.city}, ${address.state} ${address.postalCode}`;
};
